export const COMPANY = {
  name: "Groupe Lupatash Service",
  short: "GLS",
  legal: "Groupe Lupatash Service SARL",
  tagline: "Agence en Douane",
  phone: "+243 975 007 535",
  email: "lupatashservicegls@gmail.com",
  address: "69B avenue Maniema, Lubumbashi, RDC",
  addressKinshasa: "Av. du Commerce, Local 6/A, Galerie du 30 Juin, C/Gombe, Kinshasa, RDC",
  founded: 2019,
  logo: "/logo-gls.png",
  whatsapp: "243975007535",
};

export const IMAGES = {
  heroPort: "https://images.unsplash.com/photo-1670121180530-cfcba4438038?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxjYXJnbyUyMHBvcnQlMjBzaGlwcGluZyUyMGNvbnRhaW5lcnN8ZW58MHx8fHwxNzgyODM5NzE5fDA&ixlib=rb-4.1.0&q=85",
  portCranes: "https://images.unsplash.com/photo-1691591765923-3bd6f12f4209?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxjYXJnbyUyMHBvcnQlMjBzaGlwcGluZyUyMGNvbnRhaW5lcnN8ZW58MHx8fHwxNzgyODM5NzE5fDA&ixlib=rb-4.1.0&q=85",
  worker1: "https://images.unsplash.com/photo-1781559818983-4180d744416a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxsb2dpc3RpY3MlMjB3b3JrZXIlMjB3YXJlaG91c2V8ZW58MHx8fHwxNzgyODM5NzE5fDA&ixlib=rb-4.1.0&q=85",
  worker2: "https://images.unsplash.com/photo-1740914994162-0b2a49280aeb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxsb2dpc3RpY3MlMjB3b3JrZXIlMjB3YXJlaG91c2V8ZW58MHx8fHwxNzgyODM5NzE5fDA&ixlib=rb-4.1.0&q=85",
  truck: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxjYXJnbyUyMHRydWNrJTIwaGlnaHdheSUyMHRyYW5zcG9ydCUyMGxvZ2lzdGljc3xlbnwwfHx8fDE3ODI4Mzk4MDF8MA&ixlib=rb-4.1.0&q=85",
  truck2: "https://images.unsplash.com/photo-1616432043562-3671ea2e5242?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxjYXJnbyUyMHRydWNrJTIwaGlnaHdheSUyMHRyYW5zcG9ydCUyMGxvZ2lzdGljc3xlbnwwfHx8fDE3ODI4Mzk4MDF8MA&ixlib=rb-4.1.0&q=85",
  scan1: "https://images.unsplash.com/photo-1664382953403-fc1ac77073a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxjdXN0b21zJTIwb2ZmaWNlciUyMHNjYW5uaW5nJTIwd2FyZWhvdXNlJTIwYm94ZXN8ZW58MHx8fHwxNzgyODM5ODAxfDA&ixlib=rb-4.1.0&q=85",
  scan2: "https://images.unsplash.com/photo-1622127922075-fb1d21fbacbf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxjdXN0b21zJTIwb2ZmaWNlciUyMHNjYW5uaW5nJTIwd2FyZWhvdXNlJTIwYm94ZXN8ZW58MHx8fHwxNzgyODM5ODAxfDA&ixlib=rb-4.1.0&q=85",
  mining: "https://images.unsplash.com/photo-1760568787655-247d67618f37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxtaW5pbmclMjB0cnVja3MlMjBoZWF2eSUyMGluZHVzdHJ5fGVufDB8fHx8MTc4MjgzOTgwMXww&ixlib=rb-4.1.0&q=85",
  automobile: "https://images.unsplash.com/photo-1720014836833-20d9992a510f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxhdXRvbW9iaWxlJTIwY2FycyUyMHNoaXBwaW5nJTIwbG9naXN0aWNzfGVufDB8fHx8MTc4MjgzOTgwMXww&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    icon: "ClipboardCheck",
    title: "Dédouanement",
    desc: "Procédures douanières complètes : déclarations import/export, classement tarifaire, et gestion des régimes douaniers en toute conformité.",
  },
  {
    icon: "Ship",
    title: "Import & Export",
    desc: "Coordination de bout en bout de vos flux internationaux, du port d'origine jusqu'à la livraison finale, par voie maritime et terrestre.",
  },
  {
    icon: "Truck",
    title: "Transport & Logistique",
    desc: "Acheminement sécurisé de vos marchandises avec une flotte adaptée aux secteurs miniers, automobiles et industriels.",
  },
  {
    icon: "FileCheck2",
    title: "Transit & Conseil",
    desc: "Accompagnement réglementaire, gestion documentaire et optimisation des coûts de transit pour vos opérations transfrontalières.",
  },
  {
    icon: "ScanLine",
    title: "Inspection & Scanning",
    desc: "Contrôle, scan et vérification des cargaisons par notre équipe de professionnels agréés pour une traçabilité totale.",
  },
  {
    icon: "Warehouse",
    title: "Entreposage",
    desc: "Solutions d'entreposage sous douane et stockage temporaire sécurisé pour vos marchandises en attente de dédouanement.",
  },
];

export const SECTORS = [
  {
    title: "Mines",
    desc: "Expertise reconnue dans l'import/export d'équipements et de produits miniers, avec une maîtrise des contraintes logistiques lourdes.",
    image: "https://images.unsplash.com/photo-1760568787655-247d67618f37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxtaW5pbmclMjB0cnVja3MlMjBoZWF2eSUyMGluZHVzdHJ5fGVufDB8fHx8MTc4MjgzOTgwMXww&ixlib=rb-4.1.0&q=85",
    icon: "Pickaxe",
  },
  {
    title: "Automobile",
    desc: "Transit et dédouanement de véhicules et de pièces détachées, avec une logistique dédiée au transport automobile.",
    image: "https://images.unsplash.com/photo-1720014836833-20d9992a510f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxhdXRvbW9iaWxlJTIwY2FycyUyMHNoaXBwaW5nJTIwbG9naXN0aWNzfGVufDB8fHx8MTc4MjgzOTgwMXww&ixlib=rb-4.1.0&q=85",
    icon: "Car",
  },
  {
    title: "Pharmaceutique",
    desc: "Gestion rigoureuse des produits sensibles, dans le respect des normes sanitaires et des chaînes de conservation.",
    image: "https://images.unsplash.com/photo-1622127922075-fb1d21fbacbf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxjdXN0b21zJTIwb2ZmaWNlciUyMHNjYW5uaW5nJTIwd2FyZWhvdXNlJTIwYm94ZXN8ZW58MHx8fHwxNzgyODM5ODAxfDA&ixlib=rb-4.1.0&q=85",
    icon: "Pill",
  },
  {
    title: "Commercial",
    desc: "Solutions complètes pour les marchandises commerciales, de l'approvisionnement à la distribution sur le marché local.",
    image: "https://images.unsplash.com/photo-1664382953403-fc1ac77073a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxjdXN0b21zJTIwb2ZmaWNlciUyMHNjYW5uaW5nJTIwd2FyZWhvdXNlJTIwYm94ZXN8ZW58MHx8fHwxNzgyODM5ODAxfDA&ixlib=rb-4.1.0&q=85",
    icon: "ShoppingCart",
  },
];

export const PARTNERS = [
  { name: "AECL", icon: "Building2" },
  { name: "SicoMine", icon: "Pickaxe" },
  { name: "Jambo Mart", icon: "ShoppingCart" },
  { name: "Malibu Cars", icon: "Car" },
  { name: "Industrie Minière", icon: "Factory" },
  { name: "Commerce Global", icon: "Globe" },
];

export const STATS = [
  { value: "2019", label: "Année de création" },
  { value: "4+", label: "Secteurs d'expertise" },
  { value: "20+", label: "Partenaires de confiance" },
  { value: "100%", label: "Conformité douanière" },
];

export const TEAM = [
  {
    name: "Mme Lukenge Pataoli Asha Konde",
    role: "Directrice Générale",
    photo: "https://customer-assets-0z36b82j.emergentagent.net/job_import-export-gls/artifacts/p8uu6fvc_ed52cb72-17be-4b2c-849f-1b5e81563b02.JPG",
    desc: "À la tête du Groupe Lupatash Service depuis sa création, elle pilote la vision stratégique de l'agence et veille à l'excellence de chaque opération douanière.",
  },
];

export const TESTIMONIALS = [
  {
    company: "SicoMine",
    author: "Direction Logistique",
    icon: "Pickaxe",
    quote:
      "GLS gère le dédouanement de nos équipements miniers avec une rigueur exemplaire. Les délais sont respectés et la conformité est totale, même sur les cargaisons les plus complexes.",
  },
  {
    company: "Malibu Cars",
    author: "Service Import",
    icon: "Car",
    quote:
      "Pour l'importation de nos véhicules, GLS est un partenaire de confiance depuis des années. Transit rapide, documentation impeccable et un suivi permanent de chaque dossier.",
  },
  {
    company: "Jambo Mart",
    author: "Responsable Approvisionnement",
    icon: "ShoppingCart",
    quote:
      "Leur équipe connaît parfaitement les procédures douanières congolaises. Nos marchandises commerciales arrivent en rayon sans retard, une vraie tranquillité d'esprit.",
  },
  {
    company: "AECL",
    author: "Direction des Opérations",
    icon: "Building2",
    quote:
      "Un professionnalisme rare dans le secteur. GLS anticipe les contraintes réglementaires et nous propose toujours la solution de transit la plus efficace.",
  },
];

export const DOSSIER_STATUSES = [
  { code: "recu", label: "Dossier reçu" },
  { code: "documents", label: "Vérification des documents" },
  { code: "declaration", label: "Déclaration en douane" },
  { code: "liquidation", label: "Liquidation & paiement" },
  { code: "libere", label: "Marchandise libérée" },
  { code: "livre", label: "Livré" },
];

export const NAV_LINKS = [
  { label: "Accueil", href: "#accueil" },
  { label: "À propos", href: "#apropos" },
  { label: "Services", href: "#services" },
  { label: "Secteurs", href: "#secteurs" },
  { label: "Équipe", href: "#equipe" },
  { label: "Partenaires", href: "#partenaires" },
  { label: "Suivi", href: "#suivi" },
  { label: "Contact", href: "#contact" },
];
